import { SlackIntegrationCard } from '@/modules/slack-connect';

/**
 * Integrations settings — connected tools that aren't job boards (Slack, and
 * future adapters). Job-board integrations (Idibu) live on the Job Board page.
 * Stack additional integration cards here as we add them.
 */
export function IntegrationsPage() {
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <header className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Integrations</h1>
        <p className="text-sm text-gray-500 mt-1">
          Connect Lantern to the tools your team already works in.
        </p>
      </header>
      <SlackIntegrationCard />
    </div>
  );
}
